import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row } from 'react-bootstrap';
import DamFolderGroupCard from '../../../../Components/Card/DamFolderGroupCard/DamFolderGroupCard';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { deleteDamFolderGroupByIdAction, fetchDamDeletedFolders, filterFolderSortData } from '../store/DamFolder.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { useDamFolderModuleState } from '../Provider';

function BinFolder() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const { damAddEditAccess, damDeleteAccess } = useDamFolderModuleState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const {
    damFolderData: {
      filterValues: { pageIndex, pageSize, searchText },
      damDeletedFolders,
      damDeletedCount,
    },
  } = useSelector((reduxState) => reduxState);

  const [state, setState] = useState({
    damFolderGroupList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    searchLoaded: false,
    archiveIds: [],
    activeAcrhiveModal: false,
    isArchiveState: false,
    archivedComment: '',
    activeList: 'folder',
    archivedList: [],
    binList: [],
  });

  useEffect(() => {
    if (damDeletedCount > damDeletedFolders.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damDeletedFolders, damDeletedCount]);

  useEffect(() => {
    const callFn = async () => {
      setState((prev) => ({ ...prev, loading: true }));
      const params = {
        pageIndex,
        pageSize,
        searchText,
      };
      await dispatch(fetchDamDeletedFolders(params));
      setState((prev) => ({ ...prev, loading: false }));
    };
    callFn();
  }, [dispatch, state.activeList]);

  useEffect(() => {
    if (Array.isArray(damDeletedFolders)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        binList: damDeletedFolders,
      }));
    }
  }, [damDeletedFolders]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: damDeletedCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterFolderSortData(obj));
    await dispatch(fetchDamDeletedFolders(params));
  };

  const deleteDam = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damGroupId = [selectedBomLibraryGroupId];
    } else {
      params.damGroupId = [...selectedIdArray];
    }
    params.bin = true;
    const res = await dispatch(deleteDamFolderGroupByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damFolderGroupList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setBomId(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      damFolderGroupList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };
    await dispatch(fetchDamDeletedFolders(params));
  };

  return (
    <div>
      <InfiniteScroll dataLength={state?.binList?.length} next={handlePageNextInScroll} hasMore={state?.hasMore} loader={state?.loading && <Loader />}>
        <div className="container-fluid my-3">
          <Row>
            {state?.binList?.map((item, i) => (
              <DamFolderGroupCard
                key={item?._id}
                item={item}
                index={i}
                onDelete={deleteDam}
                damAddEditAccess={damAddEditAccess}
                damDeleteAccess={damDeleteAccess}
              />
            ))}
          </Row>
          {state?.binList?.length === 0 && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
        </div>
      </InfiniteScroll>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE_GROUP')}
          title="Delete"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
    </div>
  );
}

export default BinFolder;
